export default ({ fill = "#111928", size = "18" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7078_55382)">
      <path
        d="M9.19336 1.23403C9.0668 1.18833 8.92969 1.18833 8.80664 1.23403L1.55039 3.89185L9 6.82036L16.4496 3.89536L9.19336 1.23403ZM1.125 13.5598C1.125 13.7954 1.27266 14.0063 1.49414 14.0872L8.4375 16.6325V7.80474L1.125 4.93247V13.5598ZM9.5625 16.6325L16.5059 14.0872C16.7273 14.0063 16.875 13.7954 16.875 13.5598V4.93247L9.5625 7.80474V16.629V16.6325ZM8.41992 0.17583C8.79609 0.0387207 9.20742 0.0387207 9.58008 0.17583L16.8926 2.85825C17.557 3.10083 18 3.73364 18 4.4438V13.5598C18 14.2665 17.557 14.8993 16.8926 15.1454L9.58008 17.8243C9.20391 17.9614 8.79258 17.9614 8.41992 17.8243L1.10742 15.1418C0.442969 14.8993 0 14.2665 0 13.5598V4.4438C0 3.73716 0.442969 3.10435 1.10742 2.85825L8.41992 0.17583Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_7078_55382">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
